export default __webpack_public_path__ + "static/media/HECO.bd96c382.svg";